module.exports = __webpack_public_path__ + "static/img/color-palette-2.774d2796.svg";